export const parseRewardsWonStat = (user) => {
  const { rewards_won_count = 0 } = user;
  return rewards_won_count;
};

export const parseRewardsLeaderboardStat = (user) => {
  const { rewards_leaderboard_count = 0 } = user;
  return rewards_leaderboard_count;
};

export const parseRewardsStatSum = (user) => {
  return parseRewardsWonStat(user) + parseRewardsLeaderboardStat(user);
};

export const parseSocialMessagesStat = (user) => {
  const { unread_count = 0 } = user;
  return unread_count;
};

export const parseSocialNotificationsStat = (user) => {
  const { unread_notifications_count = 0 } = user;
  return unread_notifications_count;
};

export const parseSocialGroupsStat = (user) => {
  const { team_invites_count = 0, team_requests_count = 0 } = user;
  return team_invites_count + team_requests_count;
};

export const parseSocialUserStat = (user) => {
  const {
    clients_list_requests_count = 0,
    client_join_requests_count = 0,
    achievement_undo_requests_count = 0,
  } = user;
  return (
    client_join_requests_count +
    clients_list_requests_count +
    achievement_undo_requests_count
  );
};

export const parseSocialExpertStat = (user) => {
  const {
    coach_requests_count = 0,
    module_invites_count = 0,
    data_connection_requests_count = 0,
  } = user;
  return (
    coach_requests_count + module_invites_count + data_connection_requests_count
  );
};

export const parseSocialFriendRequestsStat = (user) => {
  const { friend_requests_count = 0 } = user;
  return friend_requests_count;
};

export const parseSocialStatSum = (user) => {
  return (
    parseSocialFriendRequestsStat(user) +
    parseSocialExpertStat(user) +
    parseSocialGroupsStat(user) +
    parseSocialUserStat(user) +
    parseSocialMessagesStat(user) +
    parseSocialNotificationsStat(user)
  );
};

export const parseNotificationStatSum = (user) => {
  return (
    parseSocialFriendRequestsStat(user) +
    parseSocialExpertStat(user) +
    parseSocialGroupsStat(user) +
    parseSocialUserStat(user) +
    parseSocialNotificationsStat(user) +
    parseApproveStatSum(user) +
    parseApproveProStatSum(user)
  );
};

export const parseApproveStatSum = (user) => {
  const { approve_count = 0 } = user;
  return approve_count;
};

export const parseApproveProStatSum = (user) => {
  const { professional_to_do_count = 0 } = user;
  return professional_to_do_count;
};

export const parseContentReportsStat = (user) => {
  const { content_reports_to_do = 0 } = user;
  return content_reports_to_do;
};
